import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import { getActiveLanguage, getSectionFromUrl } from "../../../utilites/util";
import { setActiveLanguage } from "../language/actions";
import { setActiveSection } from "../section/actions";
import ActionTypes from "../../../constants/ActionTypes";

const initMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.INIT:
    next(setActiveLanguage({ language: getActiveLanguage() }));
    next(setActiveSection({ section: getSectionFromUrl() }));
    break;
  }
};
export default initMiddleware;
